import { Box, Grid, Typography } from "@mui/material";
import React from "react";
import LanguageSelector from "../form-fields/language-selector";
import { getUserDetails } from "../../utils/sessionUtils";

const PCMCHeader = () => {
  const userDetails = getUserDetails();

  return (
    <Box
      sx={{
        bgcolor: "#2E8ABF",
      }}
    >
      <Grid container spacing={2}>
        <Grid
          item
          xs={12}
          sm={9}
          md={9}
          sx={{
            display: "inline-flex",
            justifyContent: "space-between",
          }}
        >
          <>
            <Grid item md={3}>
              <a href="/home">
                <Box
                  component="img"
                  sx={{
                    display: "flex",
                    width: { md: "95px", xs: "95px" }, // Set the width of the image
                    height: { md: "70px", xs: "54px" }, // Automatically adjust the height to maintain aspect ratio
                    justifyContent: {
                      md: "start",
                      xs: "center",
                    },
                  }}
                  alt="PCMC"
                  src="/pcmclogo.jpeg"
                />
              </a>
            </Grid>
            <Grid item md={9} mt={2}>
              <Typography
                sx={{
                  fontWeight: "bold",
                  fontSize: { md: "16px", sm: "15px", xs: "13px" },
                  color: "white",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                पिंपरी चिंचवड महानगरपालिका,पिंपरी - ४११०१८
              </Typography>
              <Typography
                sx={{
                  fontWeight: "bold",
                  fontSize: { md: "16px", sm: "15px", xs: "13px" },
                  color: "white",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                {" "}
                कर संकलन विभाग
              </Typography>
            </Grid>
          </>
        </Grid>
        <Grid item xs={12} sm={3} md={3}>
          {userDetails.userCode && userDetails.userName && (
            <>
              <Grid
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginBottom: "7px",
                  marginTop: "5px",
                }}
              >
                <LanguageSelector />
              </Grid>
              {/* <Grid
                sx={{
                  display: "inline-flex",
                  marginTop: "9px",
                }}
              ></Grid> */}
            </>
          )}
        </Grid>
      </Grid>
    </Box>
  );
};

export default PCMCHeader;
